// https://fancyapps.com/docs/ui/fancybox
// https://www.npmjs.com/package/axios
// https://greensock.com/
// https://swiperjs.com/get-started

declare var Swiper : any;
declare var $ : any;
declare var AOS : any;
declare var gsap : any;
declare var Fancybox:any;
declare var Carousel:any;
declare var Panzoom:any;

// Fancybox.defaults.ScrollLock = false;

// AOS.init({
//   once: true
// });

// import axios from "axios";

//////////////////////////////////////////////////////////
import {_base} from "./libraries/_base";
_base();

import {initForm} from "./libraries/_initForm";
import {initPage} from "./libraries/pagination";
import {_imgClass} from "./libraries/_imgClass";

// Common function
import constants from "./components/_constants";
import {formSytle} from "./components/_form";
import {boxForm} from "./components/_box-form";
// import {fancyboxLib} from "./components/fancybox-lib";
import {boxHistory} from "./components/_box-history";
import {boxTable} from "./components/_box-table";

// import {validator} from "./libraries/_validator";
import {sw} from "./libraries/swiper";

// Layout
import {sidebar} from "./layout/sidebar";
import {header} from "./layout/header";
import {breadcrumbs} from "./layout/breadcrumbs";
import {popup} from "./layout/popup";

// Page
import {index} from "./pages/index";

//////////////////////////////////////////////////////////////
window.addEventListener('DOMContentLoaded', function() {
  // libraries
  // base();
  _imgClass();
  initForm();initPage();

  // ----- Common in here ----- //
  sw();
  constants();boxHistory();formSytle();boxForm();boxTable();
  // validator();
  // ----- Layout in here ----- //
  sidebar(); header(); breadcrumbs();popup();
  // ----- Page in here ----- //
  index();
})

/////////////////////WEB FULLPAGE///////////////////////////
// import loadingAni from "./initAnimation/loading";

// const fullpageLoad = function(){
//   let loading = document.querySelector('#loading-container');
//   loadingAni.aniIn();
//   // import animateFullpage from "./components/animateFullpage";
//   // animateFullpage.default();
  
//   window.addEventListener('load', function() {
//     // swiper_nav();
//     allJs();
//     setTimeout(function(){
//       loading.classList.add('hiddenLoading');
//       setTimeout(function(){
//         loading.parentElement.removeChild(loading);

//         // let utiSubMap = document.getElementById('UtilitiesSubPage');
//         // if (utiSubMap){
//         //   let map = utiSubMap.querySelector('.map');
//         //   map.classList.add('animateActive');
//         // }
//       }, 700)
//       common();
//     }, loadingAni.delay)
//   })
// }

// fullpageLoad();

/////////////////////WEB NORMAL///////////////////////////

